// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3UfHw","select":"Header_select__3QGU_","clinic":"Header_clinic__QMqO9"};